import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/Header'
import { useColors } from '@/lib/utils'
import { useThemeStore } from '@/stores/theme'

export const Route = createFileRoute('/_authenticated/monthly')({
  component: MonthlyPage,
})

function MonthlyPage() {
  const { isDarkMode } = useThemeStore()
  const Colors = useColors(isDarkMode)

  return (
    <div className="flex-1">
      <Header 
        title="Monthly Reports" 
        onOpenFilters={() => {}}
      />
      
      <div className="p-6">
        <div 
          className="p-6 rounded-xl shadow-sm text-center"
          style={{ 
            backgroundColor: Colors.background.paper,
            boxShadow: isDarkMode 
              ? '0 2px 4px rgba(0, 0, 0, 0.2)' 
              : '0 2px 4px rgba(0, 0, 0, 0.05)',
          }}
        >
          <h3 className="text-xl font-inter-semibold mb-2" style={{ color: Colors.text.primary }}>
            Monthly reports coming soon
          </h3>
          <p className="font-inter-regular max-w-md mx-auto" style={{ color: Colors.text.secondary }}>
            This section will contain monthly performance metrics, trends, and comparisons.
          </p>
        </div>
      </div>
    </div>
  )
}